import Recognition from './Recognition';

export default Recognition;